// extracted by mini-css-extract-plugin
export default {"productCarousel":"RY-z"};